import React from "react";
import styled, { createGlobalStyle } from "styled-components"
import { EColor as EColor } from "../../styleConstants";
import { breakPoint } from "../styleUtils";


type WrapperProps = {
    background: EColor
    overflow: string
}

const Wrapper = styled.div<WrapperProps>`
    position: relative;
    background: ${props => props.background ? props.background : "none" };
    background-attachment: ${props => props.background ? "inherit" : "fixed" };
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    overflow: ${props => props.overflow ? props.overflow : "hidden" };
`

export default function SectionWrapper ({
    children,
    background,
    overflow,
}: {
    children: JSX.Element|JSX.Element[]
    background? : EColor
    overflow?: string
}) {
    return (
        <Wrapper background={background} overflow={overflow}>
            {children}
        </Wrapper>
    )
}